import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Select2SearchEvent, Select2UpdateEvent } from 'ng-select2-component';
import { IDetailFormField, IDetailFormFieldChange } from 'src/app/models';
import { InputType } from 'src/app/models/enums';
import { UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { DetailComponent } from '../detail/detail.component';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'app-detail-form',
  templateUrl: './detail-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DetailComponent, InputComponent],
})
export class DetailFormComponent {
  readonly fields = input.required<IDetailFormField[]>();
  readonly edit = input(false);
  readonly invalidFields = input<string[]>([]);
  readonly fieldChange = output<IDetailFormFieldChange>();

  constructor(
    public literalService: LiteralService,
    private utilsService: UtilsService,
  ) {}

  onChange(event: Event, field: IDetailFormField) {
    const target = event.target as HTMLInputElement | null;
    switch (field.edit?.inputType) {
      case InputType.TOGGLE:
      case InputType.CHECKBOX:
        return this.emitChange(field, !!target?.checked);
      case InputType.MULTISELECT:
        return this.emitChange(field, (field.edit.selectedValues ?? []).map((value: { id: unknown }) => value.id));
      case InputType.NUMBER:
        return this.emitChange(field, this.utilsService.toOptionalNumber(target?.value));
      default:
        return this.emitChange(field, target?.value ?? null);
    }
  }

  onSet(event: Select2UpdateEvent, field: IDetailFormField) {
    this.emitChange(field, event.value);
  }

  async onSearch(event: Select2SearchEvent, field: IDetailFormField) {
    if (!field.loadOptions || !field.edit) return;
    const options = await field.loadOptions(event.search ?? '');
    field.edit.values = this.utilsService.toSelectOptions(options);
  }


  private emitChange(field: IDetailFormField, value: unknown) {
    const fieldName = field.edit?.valueToChange;
    if (fieldName) this.fieldChange.emit({ field: fieldName, value });
  }
}
